export const ribbonList = ['hot', 'mega_deal', 'new', 'placeholder', 'text'];

export const categoryMenu = [
  {
    name: 'Air Conditioner',
    image: '/images/air-conditioner-2.png',
    url: '#',
  },
  {
    name: 'Refrigerators',
    image: '/images/refrigerator-1.png',
    url: '#',
  },
  {
    name: 'Televisions',
    image: '/images/television.png',
    url: '#',
  },
  {
    name: 'Kitchen Appliances',
    image: '/images/kitchen-appliances.png',
    url: '#',
  },
  {
    name: 'Ovens',
    image: '/images/oven-1.png',
    url: '#',
  },
  {
    name: 'Hood & Hob',
    image: '/images/hood-hob-1.png',
    url: '#',
  },
  {
    name: 'Washing Machine',
    image: '/images/washing-machine.png',
    url: '#',
  },
  {
    name: 'Small Appliances',
    image: '/images/small-appliance.png',
    url: '#',
  },
  {
    name: 'Sewing Machine',
    image: '/images/sewing-machine.png',
    url: '#',
  },
  {
    name: 'Computers & Accessories',
    image: '/images/computer-accessories.png',
    url: '#',
  },
  {
    name: 'Smart Gadgets',
    image: '/images/smart-gadget.png',
    url: '#',
  },
  {
    name: 'Power Solutions',
    image: '/images/power-solution.png',
    url: '#',
  },
  {
    name: 'Spare Parts',
    image: '/images/spareparts.png',
    url: '#',
  },
  {
    name: 'Dishwasher',
    image: '/images/dishwasher.png',
    url: '#',
  },
  {
    name: 'Waterheater',
    image: '/images/waterheater.png',
    url: '#',
  },
];

export const brands = [
  {
    name: 'Blueair',
  },
  {
    name: 'Dell',
  },
  {
    name: 'Galanz',
  },
  {
    name: 'Haier',
  },
  {
    name: 'Havells',
  },
  {
    name: 'Hisense',
  },
  {
    name: 'HP',
  },
  {
    name: 'Lenovo',
  },
  {
    name: 'Panasonic',
  },
  {
    name: 'Preethi',
  },
  {
    name: 'Samsung',
  },
  {
    name: 'Skyworth',
  },
  {
    name: 'Symphony',
  },
  {
    name: 'Toshiba',
  },
  {
    name: 'Unilever',
  },
  {
    name: 'V-Guard',
  },
  {
    name: 'Videocon',
  },
  {
    name: 'Whirlpool',
  },
  {
    name: 'Whirlpool',
  },
];

export const defaultAll = {
  id: 1,
  name: 'All',
  slug: 'all',
  url: '#',
};

export const EMI_ELIGIBLE_PRICE = 10000;

export const cancelOrderOption = {
  value: 'canceled',
  label: 'Cancelled',
  url: '/my-orders?tab=canceled',

  name: 'Cancelled',
  icon: 'cancellation-icon',
  link: '/my-orders?tab=canceled',

  id: 'cancelOrders',
  activeValue: 'canceled',
};
